var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_67301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12109 2.625C7.36272 2.625 7.55859 2.82088 7.55859 3.0625C7.55858 3.30412 7.36271 3.5 7.12109 3.5H1.31445C1.0729 3.50008 0.876953 3.69593 0.876953 3.9375V12.6875C0.876963 12.9291 1.07291 13.1249 1.31445 13.125H10.0645C10.3061 13.125 10.5019 12.9291 10.502 12.6875V6.88086C10.502 6.63929 10.6979 6.44344 10.9395 6.44336C11.1811 6.44336 11.377 6.63924 11.377 6.88086V12.6875C11.3769 13.4124 10.7893 14 10.0645 14H1.31445C0.589656 13.9999 0.00196311 13.4123 0.00195312 12.6875V3.9375C0.00195312 3.21268 0.58965 2.62508 1.31445 2.625H7.12109ZM13.5645 0C13.8061 0 14.002 0.195875 14.002 0.4375V4.8125C14.0019 5.05412 13.8061 5.25 13.5645 5.25C13.3229 5.24992 13.127 5.05406 13.127 4.8125V1.49414L5.99902 8.62207C5.82816 8.79284 5.55071 8.7929 5.37988 8.62207C5.20913 8.45124 5.20914 8.17377 5.37988 8.00293L12.5088 0.875H9.18945C8.94791 0.874916 8.75196 0.679064 8.75195 0.4375C8.75195 0.195927 8.9479 8.35421e-05 9.18945 0H13.5645Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_67301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0c237a5b30a9e584d460ce835b53c874.svg";
export { ForwardRef as ReactComponent };